<button class="tab-trap" tabindex="0"></button>

<div class="dialog-content">
    <div  class="content" *ngIf="confirmationPanel !== true && this.isSubmitted !== true">       
        <div class="title">
            <h1>Confirm to Cancel</h1>
            <button class="close-icon" mat-dialog-close mat-icon-button tabindex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="dd-logo">
            <img class="logo" src="../../../assets/icons/logo-dd-shipping-intelligence.svg"
                alt="logo-dd-shipping-intelligence">
        </div>
        <h2>Not ready to cancel? Here are some features to consider.</h2>
        <div class="featurePanel">
            <h3>Features</h3>
            <ul>
                <li><span> <img class="checkmark_1" src="../../../assets/icons/checkmark_1.svg" alt="checkmark_1">
                    </span><h1 class="trademark">Proactive loss control to help improve outcomes</h1></li>
                <li><span> <img class="checkmark_1" src="../../../assets/icons/checkmark_1.svg" alt="checkmark_1">
                    </span><h1 class="trademark">Delivery intelligence to support smarter shipping decisions</h1></li>
                <li><span> <img class="checkmark_1" src="../../../assets/icons/checkmark_1.svg" alt="checkmark_1">
                    </span><h1 class="trademark">Integrated decisioning to streamline workflows</h1></li>
                <li><span> <img class="checkmark_1" src="../../../assets/icons/checkmark_1.svg" alt="checkmark_1">
                    </span><h1 class="trademark">Flexible alternate delivery options such as UPS Access Point<span class="ratedSymbal">®</span>locations</h1></li>
            </ul>
            <h5>Cancellation will take effect at the end of the calendar month. You can restart your subscription at any time.</h5>
        </div>

        <div class="actionButton">
            <button type="submit" (click)="cancelSubscription($event)" mat-stroked-button color="primary">Cancel Subscription</button>
            <button id="buttonCls" type="submit" (click)="keepSubscription($event)" mat-flat-button color="primary">Keep
                Subscription</button>
        </div>



    </div>
    
        <div *ngIf="confirmationPanel === true" class="cancelPanel">
            <div class="title">
                <h1>Before you go,<br>
                    tell us how can we assist you better.</h1>
                <button class="close-icon" mat-dialog-close mat-icon-button tabindex="-1">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="cancelContent">
                <div class="dropdown">
                    <h2>What made you cancel the subscription?</h2>
                    <form [formGroup]="ReasonsFormGroup" class="ups-form">
                        <mat-form-field class="ddPanel borderActive" appearance="outline">
                            <mat-select  class="selectPanel" disableOptionCentering placeholder="Reasons..." panelClass="select-style" formControlName="reason">
                                <mat-option  *ngFor="let reason of reasons" [value]="reason">
                                    {{reason}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="ReasonsFormGroup.controls.reason?.errors">
                                <span *ngIf="ReasonsFormGroup.controls.reason?.errors?.required">
                                    Reason is required
                                </span>
                            </mat-error>
                        </mat-form-field>
                        <div class="description">
                            <h2>Description (optional)</h2>
                            <mat-form-field subscriptSizing="dynamic">
                                <textarea placeholder="Tell us more about your opinion" id="description" formControlName="description"
                                    name="description" rows="4" matInput></textarea>
                            </mat-form-field>
                        </div>
                    </form>
                </div>
      


            </div>
            <div class="actionButton">
              
                <button mat-stroked-button color="primary" id="submitbutton" type="button" [disabled]="!this.ReasonsFormGroup.valid" (click)="submitbtn($event)">Submit</button>
                <!-- <button mat-raised-button type="button" [disabled]="!this.ReasonsFormGroup.valid" (click)="submitbtn($event)" class="submit form-action">Submit</button> -->
                <button id="buttonCls" type="submit" (click)="keepSubscription($event)" mat-flat-button color="primary">Keep
                    Subscription</button>
            </div>
        </div>
    
   
        <div  *ngIf="isSubmitted === true" class="submittedPanel">
            <div class="title">
                <h1>Subscription Canceled</h1>
                    <div class="separator"></div>
                <button class="close-icon" mat-dialog-close mat-icon-button tabindex="-1" (click)="closeDialogOnCancel($event)">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="cancelContent">
               
                <h1>We're sorry to see you go. <br>
                    Your access to DeliveryDefense™ Address Confidence  will end on <span [innerHTML]="formattedDate"></span>, but you can restart your subscription at any time.</h1>
               
            </div>
            <div class="actionButton">
                <button id="buttonCls" type="submit" (click)="restartbtn($event)" mat-flat-button color="primary">Restart
                    Subscription</button>
            </div>
        </div>
    
</div>
